export default __webpack_public_path__ + "images/JT.c4960e3.png";